<template>
  <div>
    <header
      id="header"
      class="header header-bg-transparent header-abs-top py-3"
    >
      <div class="header-section">
        <div id="logoAndNav" class="container">
          <nav class="navbar">
            <router-link class="navbar-brand" to="/" aria-label="Front">
              <img src="@/assets/svg/logos/logo.svg" alt="Logo" />
            </router-link>
          </nav>
        </div>
      </div>
    </header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="d-flex">
        <div class="container d-flex align-items-center vh-100">
          <div class="row justify-content-md-center flex-md-grow-1 text-center">
            <div class="col-md-9 col-lg-8">
              <img
                class="img-fluid mb-2"
                src="@/assets/svg/illustrations/maintenance-mode.svg"
                alt="SVG Illustration"
              />
              <h1 class="h2">我们正在调整和完善一些内容</h1>
              <p class="p">
                对于给您带来的不便，我们深表歉意，网站目前正在按计划进行维护！
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- End Hero Section -->
    </main>
    <footer class="position-absolute right-0 bottom-0 left-0">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center space-1">
          <!-- Copyright -->
          <p class="small text-muted mb-0">
            © 创联天成. 2019-2022 CLTC.info . All rights reserved. 
          </p>
          <!-- End Copyright -->

          <!-- Social Networks -->
          <ul class="list-inline mb-0">
            <p class="small text-muted mb-0">晋ICP备20000031号-1</p>
          </ul>
          <!-- End Social Networks -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/js/hs.core.js";
export default {
  components: {},
};
</script>

<style scoped>
.h2 {
  margin-bottom: 0.5rem;
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/wait.vue